module.exports = __webpack_public_path__ + "static/media/credit-query.6075917b.svg";